import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  accountName: (
    <FormattedMessage
      id="Global.AccountName"
      defaultMessage="Account/DBA Name"
    />
  ),
  address1: (
    <FormattedMessage id="Global.Address1" defaultMessage="Address 1" />
  ),
  address2: (
    <FormattedMessage id="Global.Address2" defaultMessage="Address 2" />
  ),
  affiliateMarketing: (
    <FormattedMessage
      id="Global.AffiliateMarketing"
      defaultMessage="Affiliate Marketing"
    />
  ),
  ageGated: (
    <FormattedMessage id="Global.AgeGated" defaultMessage="Age Gated" />
  ),
  agreements: (
    <FormattedMessage id="Global.Agreements" defaultMessage="Agreements" />
  ),
  authority: (
    <FormattedMessage
      id="Global.Authority"
      defaultMessage="Proof of Authority"
    />
  ),
  autoRenewal: (
    <FormattedMessage id="Global.AutoRenewal" defaultMessage="Auto Renewal" />
  ),
  backToCustomer: (
    <FormattedMessage
      id="Global.BackToCustomer"
      defaultMessage="Back To Customer"
    />
  ),
  billingAddressSameAsPhysical: (
    <FormattedMessage
      id="Global.PostalAddressSameAsPhysical"
      defaultMessage="Same As Physical"
    />
  ),
  brandRelationship: (
    <FormattedMessage
      id="Global.BrandRelationship"
      defaultMessage="Brand Relationship"
    />
  ),
  businessClassification: (
    <FormattedMessage
      id="Global.BusinessClassification"
      defaultMessage="Business Classification"
    />
  ),
  businessClassDirect: (
    <FormattedMessage
      id="Global.BusinessClassDirect"
      defaultMessage="Direct Customer"
    />
  ),
  businessClassISV: (
    <FormattedMessage
      id="Global.BusinessClassISV"
      defaultMessage="Independent Software Vendor"
    />
  ),
  businessPhone: (
    <FormattedMessage
      id="Global.BusinessPhone"
      defaultMessage="Business Phone"
    />
  ),
  businessType: (
    <FormattedMessage id="Global.BusinessType" defaultMessage="Business Type" />
  ),
  campaign: <FormattedMessage id="Global.Campaign" defaultMessage="Campaign" />,
  city: <FormattedMessage id="Global.City" defaultMessage="City" />,
  company: (
    <FormattedMessage id="Global.CompanyInfo" defaultMessage="Company" />
  ),
  companyProfile: (
    <FormattedMessage
      id="Global.CompanyProfile"
      defaultMessage="Company Profile"
    />
  ),
  contactAuthorized: (
    <FormattedMessage
      id="Global.ContactAuthorized"
      defaultMessage="Authorized Representative"
    />
  ),
  contactBilling: (
    <FormattedMessage
      id="Global.ContactBilling"
      defaultMessage="Billing Contact"
    />
  ),
  contact: (
    <FormattedMessage id="Global.ContactInfo" defaultMessage="Contacts" />
  ),
  contactOwner: (
    <FormattedMessage id="Global.ContactOwner" defaultMessage="Account Owner" />
  ),
  contactTechnical: (
    <FormattedMessage
      id="Global.ContactTechnical"
      defaultMessage="Technical Contact"
    />
  ),
  copyFrom: (
    <FormattedMessage id="Global.CopyFrom" defaultMessage="Copy From ..." />
  ),
  country: <FormattedMessage id="Global.Country" defaultMessage="Country" />,
  csp: <FormattedMessage id="Global.Csp" defaultMessage="CSP" />,
  dca: <FormattedMessage id="Global.Dca" defaultMessage="DCA" />,
  email: <FormattedMessage id="Global.Email" defaultMessage="Email" />,
  embeddedLink: (
    <FormattedMessage id="Global.EmbeddedLink" defaultMessage="Embedded Link" />
  ),
  embeddedLinkSample: (
    <FormattedMessage
      id="Global.EmbeddedLinkSample"
      defaultMessage="Embedded Link Sample"
    />
  ),
  embeddedPhone: (
    <FormattedMessage
      id="Global.EmbeddedPhone"
      defaultMessage="Embedded Phone"
    />
  ),
  embeddedPhoneSample: (
    <FormattedMessage
      id="Global.EmbeddedPhoneSample"
      defaultMessage="Embedded Phone Sample"
    />
  ),
  entityType: (
    <FormattedMessage id="Global.EntityType" defaultMessage="Legal Form" />
  ),
  firstName: (
    <FormattedMessage id="Global.FirstName" defaultMessage="First Name" />
  ),
  helpKeywords: (
    <FormattedMessage id="Global.HelpKeywords" defaultMessage="Help Keywords" />
  ),
  helpMessage: (
    <FormattedMessage id="Global.HelpMessage" defaultMessage="Help Message" />
  ),
  identifierNumber: (
    <FormattedMessage
      id="Global.IdentifierNumber"
      defaultMessage="Identifier Number"
    />
  ),
  identifierType: (
    <FormattedMessage
      id="Global.IdentifierType"
      defaultMessage="Identifier Type"
    />
  ),
  internal: (
    <FormattedMessage id="Global.InternalTCR" defaultMessage="Internal TCR" />
  ),
  ipAddress: (
    <FormattedMessage id="Global.IpAddress" defaultMessage="IP Address" />
  ),
  isvAssignsNumbers: (
    <FormattedMessage
      id="Global.IsvAssignsNumbers"
      defaultMessage="ISV Assigns Numbers"
    />
  ),
  isvAssignsNumbersTooltip: (
    <FormattedMessage
      id="Global.IsvAssignsNumbersTooltip"
      defaultMessage="If you are an Independent Software Vendor (ISV), will you assign the Red Oxygen phone number(s) to your end customers?"
    />
  ),
  lastName: (
    <FormattedMessage id="Global.LastName" defaultMessage="Last Name" />
  ),
  legalName: (
    <FormattedMessage
      id="Global.CompanyLegalName"
      defaultMessage="Legal Name"
    />
  ),
  loanAgreements: (
    <FormattedMessage
      id="Global.LoanAgreements"
      defaultMessage="Loan Agreements"
    />
  ),
  messageDescription: (
    <FormattedMessage
      id="Global.MessageDescription"
      defaultMessage="Message Description"
    />
  ),
  messageFlow: (
    <FormattedMessage id="Global.MessageFlow" defaultMessage="Message Flow" />
  ),
  messageFlowFiles: (
    <FormattedMessage
      id="Global.MessageFlowFiles"
      defaultMessage="Message Flow Files"
    />
  ),
  messageType: (
    <FormattedMessage id="Global.MessageType" defaultMessage="Message Type" />
  ),
  messageSample: (
    <FormattedMessage
      id="Global.MessageSample"
      defaultMessage="Message Sample"
    />
  ),
  messageSample2: (
    <FormattedMessage
      id="Global.MessageSample2"
      defaultMessage="Message Sample 2"
    />
  ),
  messageSample3: (
    <FormattedMessage
      id="Global.MessageSample3"
      defaultMessage="Message Sample 3"
    />
  ),
  messageSample4: (
    <FormattedMessage
      id="Global.MessageSample4"
      defaultMessage="Message Sample 4"
    />
  ),
  messageSample5: (
    <FormattedMessage
      id="Global.MessageSample5"
      defaultMessage="Message Sample 5"
    />
  ),
  mobile: <FormattedMessage id="Global.Mobile" defaultMessage="Mobile" />,
  noFields: (
    <FormattedMessage id="Global.NoFields" defaultMessage="No Fields" />
  ),
  numberPool: (
    <FormattedMessage id="Global.NumberPool" defaultMessage="Number Pool" />
  ),
  optInKeywords: (
    <FormattedMessage
      id="Global.OptInKeywords"
      defaultMessage="Opt In Keywords"
    />
  ),
  optInMessage: (
    <FormattedMessage
      id="Global.OptInMessage"
      defaultMessage="Opt In Message"
    />
  ),
  optOutKeywords: (
    <FormattedMessage
      id="Global.OptOutKeywords"
      defaultMessage="Opt Out Keywords"
    />
  ),
  optOutMessage: (
    <FormattedMessage
      id="Global.OptOutMessage"
      defaultMessage="Opt Out Message"
    />
  ),
  phone: <FormattedMessage id="Global.Phone" defaultMessage="Phone" />,
  physicalAddress: (
    <FormattedMessage
      id="Global.PhysicalAddress"
      defaultMessage="Physical Address"
    />
  ),
  position: <FormattedMessage id="Global.Position" defaultMessage="Position" />,
  postalAddress: (
    <FormattedMessage
      id="Global.PostalAddress"
      defaultMessage="Billing Address"
    />
  ),
  privacy: (
    <FormattedMessage id="Global.Privacy" defaultMessage="Privacy/Service" />
  ),
  privacyOn: (
    <FormattedMessage
      id="Global.PrivacyOn"
      defaultMessage="Privacy Agreed On"
    />
  ),
  privacyPolicyUrl: (
    <FormattedMessage
      id="Global.PrivacyPolicyUrl"
      defaultMessage="Privacy Policy URL"
    />
  ),
  privacyTooltip: (
    <FormattedMessage
      id="Global.PrivacyTooltip"
      defaultMessage="Agree to privacy policy and service agreement"
    />
  ),
  product: (
    <FormattedMessage id="Global.Product" defaultMessage="Product/Service" />
  ),
  save: <FormattedMessage id="Global.Save" defaultMessage="Save" />,
  saving: <FormattedMessage id="Global.Saving" defaultMessage="Saving" />,
  savingMessage: (
    <FormattedMessage
      id="Global.SavingMessage"
      defaultMessage="Saving, please wait ..."
    />
  ),
  sendMessagesInternationally: (
    <FormattedMessage
      id="Global.SendMessagesInternationally"
      defaultMessage="Send Internationally"
    />
  ),
  sendToCountries: (
    <FormattedMessage
      id="Global.SendToCountries"
      defaultMessage="Send To Countries"
    />
  ),
  serviceAgreementUrl: (
    <FormattedMessage
      id="Global.ServiceAgreementUrl"
      defaultMessage="Service Agreement URL"
    />
  ),
  senderBrandRelationship: (
    <FormattedMessage
      id="Global.SenderBrandRelationship"
      defaultMessage="Rel. to Brand"
    />
  ),
  senderComments: (
    <FormattedMessage id="Global.SenderComments" defaultMessage="Comments" />
  ),
  senderId: (
    <FormattedMessage id="Global.SenderId" defaultMessage="Sender ID" />
  ),
  sender: <FormattedMessage id="Global.SenderInfo" defaultMessage="Sender" />,
  state: <FormattedMessage id="Global.State" defaultMessage="State/Province" />,
  stockExchange: (
    <FormattedMessage
      id="Global.StockExchange"
      defaultMessage="Stock Exchange"
    />
  ),
  stockExchangeSymbol: (
    <FormattedMessage
      id="Global.StockExchangeSymbol"
      defaultMessage="Stock Exchange Symbol"
    />
  ),
  subUseCases: (
    <FormattedMessage id="Global.SubUseCases" defaultMessage="Sub Use Cases" />
  ),
  subscriberHelp: (
    <FormattedMessage
      id="Global.SubscriberHelp"
      defaultMessage="Subscriber Help"
    />
  ),
  subscriberOptIn: (
    <FormattedMessage
      id="Global.SubscriberOptIn"
      defaultMessage="Subscriber Opt In"
    />
  ),
  subscriberOptOut: (
    <FormattedMessage
      id="Global.SubscriberOptOut"
      defaultMessage="Subscriber Opt Out"
    />
  ),
  taxId: (
    <FormattedMessage id="Global.TaxId" defaultMessage="Registration/Tax ID" />
  ),
  tcpa: <FormattedMessage id="Global.Tcpa" defaultMessage="TCPA" />,
  tcpaTooltip: (
    <FormattedMessage
      id="Global.TcpaTooltip"
      defaultMessage="Some sort of agreement that they've read and understand TCPA, and know that we follow the guidelines of CTIA and Australia's CAN Spam Act"
    />
  ),
  trademarkCertificate: (
    <FormattedMessage
      id="Global.TrademarkCertificate"
      defaultMessage="Trademark Certificate"
    />
  ),
  truth: (
    <FormattedMessage id="Global.Truth" defaultMessage="Filled Truthfully" />
  ),
  truthTooltip: (
    <FormattedMessage
      id="Global.TruthTooltip"
      defaultMessage="Agree that this is filled out truthfully"
    />
  ),
  useCase: <FormattedMessage id="Global.UseCase" defaultMessage="Use Case" />,
  useSenderId: (
    <FormattedMessage
      id="Global.UseSenderId"
      defaultMessage="Use a Sender ID"
    />
  ),
  website: <FormattedMessage id="Global.Website" defaultMessage="Website" />,
  zip: <FormattedMessage id="Global.Zip" defaultMessage="Zip/Postal Code" />,
};

export default FormattedMessages;
